// The text a client agrees to. Bump the version whenever the wording changes —
// client_consent rows record which version was on screen. (records-v1 was
// reworded in place on 2026-10-11, legal review D3, before any real client
// had consented.)
export const CONSENT_WORDING = {
  records: {
    version: 'records-v1',
    text: 'I agree to [business] keeping notes about my treatments, including health information I share (such as injuries, conditions, medication or pregnancy), so my treatment is safe and suited to me. I can withdraw this at any time.',
  },
  photos: {
    version: 'photos-v1',
    text: 'I agree to [business] taking photos of the area being treated and keeping them with my treatment records. I can withdraw this at any time.',
  },
} as const
